import styled from "styled-components"

const SectionDivider = styled.hr`
  background-color: ${props => props.theme.colors.grey10};
  border: none;
  height: 1px;
  margin: ${props => props.theme.space[3]} 0;
  outline: none;
  width: 100%;
`

export default SectionDivider
